import { useState } from "react";
import { FormField } from "./FormField.tsx";
import { Input } from "../atoms/Input.tsx";

interface Props {
  value: string[];
  onChange: (v: string[]) => void;
  error?: string;
}

/** Multi-select tag entry: type a tag, Enter/comma to add, × or Backspace to remove. */
export function TagInput({ value, onChange, error }: Props) {
  const [draft, setDraft] = useState("");

  const add = (raw: string) => {
    const t = raw.trim();
    if (!t) return;
    if (!value.some((x) => x.toLowerCase() === t.toLowerCase())) {
      onChange([...value, t]);
    }
    setDraft("");
  };
  const remove = (t: string) => onChange(value.filter((x) => x !== t));

  return (
    <FormField label="Tags" error={error}>
      <div className="tag-input">
        {value.map((t) => (
          <span key={t} className="tag-pill">
            {t}
            <button type="button" aria-label={`Remove ${t}`} onClick={() => remove(t)}>
              ×
            </button>
          </span>
        ))}
        <Input
          className="tag-input-field"
          value={draft}
          placeholder={value.length ? "Add another…" : "Add a tag, press Enter"}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === ",") {
              e.preventDefault();
              add(draft);
            } else if (e.key === "Backspace" && !draft && value.length) {
              remove(value[value.length - 1]!);
            }
          }}
          onBlur={() => add(draft)}
        />
      </div>
      <span className="field-hint">
        Shared vocabulary across the desk — powers related content.
      </span>
    </FormField>
  );
}
